import React from "react";
import SiteLayout from "@/components/SiteLayout";
import GameGrid from "@/sections/GameGrid";
import Clients from "@/sections/Clients";
import Testimonials from "@/sections/Testimonials";

const WorkPage = () => (
  <SiteLayout>
    <GameGrid
      section="clientwork"
      testid="work-section"
      eyebrow="Client Work"
      title='Games we&apos;ve <span style="color:#ff2a8f">built</span>'
      subtitle="Selected client projects we shipped from concept to store."
      emptyText="Client projects coming soon."
    />
    <GameGrid
      section="games"
      testid="games-section"
      eyebrow="Our Games"
      title='Original <span style="color:#2ad6ff">IPs</span>'
      subtitle="Titles we publish under our own name on Google Play &amp; the App Store."
      emptyText="Our games are launching soon."
    />
    <GameGrid
      section="assets"
      testid="assets-section"
      eyebrow="Unity Asset Store"
      title='Tools &amp; <span style="color:#c8ff2a">kits</span>'
      subtitle="Production-ready assets that help developers ship faster."
      emptyText="Asset store products coming soon."
    />
    <Testimonials />
    <Clients />
  </SiteLayout>
);

export default WorkPage;
